import Checkbox from './Checkbox';

export default Checkbox;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_rc-checkbox@2.1.5@rc-checkbox/es/index.js
// module id = null
// module chunks = 